import React from "react";
import { Tabs } from "antd";
import NotificationCard from "../cards/NotificationCard";
import {
  useAnnouncementNotifications,
  useInstructorNotifications,
  useNotifications,
} from "../../services/notification.service";
import { useMemo } from "react";

const { TabPane } = Tabs;

const STOCK_NOTIFICATION_TYPES = ["stock_request", "stock_status", "low_stock"];

export default function NotificationWidget() {
  const notifications = useNotifications();
  const instructorNotifications = useInstructorNotifications();

  const filteredNotifications = useMemo(() => {
    let data = [];
    data = notifications?.data?.filter(
      (n) => n.type === "assignment" || n.type === "exam"
    );

    return data;
  }, [notifications?.data]);

  const stockNotifications = useMemo(
    () =>
      (instructorNotifications?.data || []).filter((n) =>
        STOCK_NOTIFICATION_TYPES.includes(n.type)
      ),
    [instructorNotifications?.data]
  );

  return (
    <Tabs defaultActiveKey="1">
      {/* <TabPane tab="School" key="1">
        <div className="space-y-2">
          {announcements?.data?.length ? (
            announcements?.data?.map((announcement) => (
              <NotificationCard
                key={announcement._id}
                title={announcement?.title}
                data={announcement?.createdAt}
                description={announcement?.description}
              />
            ))
          ) : (
            <div>No notifications</div>
          )}
        </div>
      </TabPane> */}
      <TabPane tab="Classes" key="2">
        <div className="space-y-2">
          {notifications?.data?.length ? (
            filteredNotifications?.map((notification) => (
              <NotificationCard
                key={notification._id}
                title={notification?.title}
                description={notification?.description}
                date={notification?.createdAt}
              />
            ))
          ) : (
            <div>No notifications</div>
          )}
        </div>
      </TabPane>
      <TabPane tab="Stock" key="3">
        <div className="space-y-2">
          {stockNotifications.length ? (
            stockNotifications.map((notification) => (
              <NotificationCard
                key={notification._id}
                title={notification?.title}
                description={notification?.description}
                date={notification?.createdAt}
              />
            ))
          ) : (
            <div>No stock updates</div>
          )}
        </div>
      </TabPane>
    </Tabs>
  );
}
